const productionApi = "https://apigis.mea.or.th";

export const Scsprivate = (controller, apikey, word) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/embed/scs-private?search=${word}&limit=20`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};

export const ScsprivateDetail = (controller, apikey, lat, long) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/embed/scs-private/data?latitude=${lat}&longitude=${long}`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};

export const Scspublic = (controller, apikey, word) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/embed/scs-public?search=${word}&limit=20`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};

export const ScspublicDetail = (controller, apikey, lat, long) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/embed/scs-public/data?latitude=${lat}&longitude=${long}`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};
